import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router';

import { assertNever } from '@/lib/assertions';
import { ResetAuthState, useResetTokenAuth } from '@/lib/hooks/useResetTokenAuth';

import { BigSpinner } from './BigSpinner';

export const ResetTokenRoute = () => {
    const { token } = useParams();

    const navigate = useNavigate();
    const { authState, checkAuth } = useResetTokenAuth(token);

    // biome-ignore lint/correctness/useExhaustiveDependencies: one time effect
    useEffect(() => {
        if (!token) {
            navigate('/');
        }

        if (authState === ResetAuthState.PRE_AUTH) {
            checkAuth();
        }
        if (authState === ResetAuthState.NOT_AUTHENTICATED) {
            navigate('/');
        }
    }, []);

    switch (authState) {
        case ResetAuthState.PRE_AUTH:
            return <BigSpinner />;

        case ResetAuthState.NOT_AUTHENTICATED:
            return null;
        case ResetAuthState.AUTHENTICATED:
            return <Outlet />;
        default:
            assertNever(authState);
    }
};
